/* unplugin-vue-components disabled */import script from "./channelCheck.vue?vue&type=script&setup=true&lang=ts"
export * from "./channelCheck.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__